import WidgetHub from "@/components/WidgetHub";
import { Receipt, ShoppingBag } from "lucide-react";

export default function FinanceHub() {
  const widgets = [
    { label: "Receivables", description: "Sold goods · invoices, payments, ledger, aging, notes", to: "/org/finance/receivables", icon: Receipt, accent: "bg-emerald-500/10" },
    { label: "Payables", description: "Purchased goods · invoices, payments, ledger, aging, notes", to: "/org/finance/payables", icon: ShoppingBag, accent: "bg-blue-500/10" },
  ];
  return <WidgetHub title="Finance & accounting" subtitle="Two mirrored ledgers — Receivables for what you sell, Payables for what you buy. Same controls." widgets={widgets} testid="finance-hub" />;
}
